<template>
    <section class="features-sections">
      <div class="features-header-container">
          <span class="features-header" :class="$i18n.locale === 'ar' ? 'arabic-text' : ''" >{{$t('landing_page_product_benefit_title')}}</span>
      </div>
      <div class="features-grid">
        <div class="feature-item" v-for="(feature, index) in features" :key="index">
          <div class="icon-wrapper">
              <div class="circular-icon">
                <img :src="feature.icon" :alt="$t(feature.title)" class="" />
              </div>
            </div>
            <div class="feature-details">
              <h3 class="feature-title">{{ $t(feature.title) }}</h3>
              <p class="feature-description" :class="$i18n.locale === 'ar' ? 'arabic-text' : ''" >{{ $t(feature.description) }}</p>
            </div>
        </div>
      </div>
      <div class="features-image">
        <img src="../assets/images/multi-device-lp.png" alt="Kids Content" class="main-image" />
      </div>
    </section>
  </template>
  
  <script>
  export default {
    data() {
      return {
        features: [
          {
            title: "landing_page_benefit_1_title",
            description: "landing_page_benefit_1_subtitle",
            icon: require("../assets/images/Book.svg"),
          },
          {
            title: "landing_page_benefit_2_title",
            description: "landing_page_benefit_2_subtitle",
            icon: require("../assets/images/Brain.svg"),
          },
          {
            title: "landing_page_benefit_3_title",
            description: "landing_page_benefit_3_subtitle",
            icon: require("../assets/images/TV.svg"),
          },
          {
            title: "landing_page_benefit_4_title",
            description: "landing_page_benefit_4_subtitle",
            icon: require("../assets/images/Backpack.svg"),
          },
        ],
      };
    },
  };
  </script>
  
  <style scoped>
  .features-sections {
    padding: 20px 20px;
    color: white;
    text-align: center;
    margin-top: -10px;
    background-color: #020076;
  }
  .features-header-container {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 1rem;
  }
  .features-header {
    font-size: 2.5rem;
    font-weight: bold;
    margin-bottom: 1rem;
    line-height: 1;
    text-align: center;
    word-wrap: break-word;
    max-width: 800px;
    font-family: 'Nunito-ExtraBold';

    @media (orientation: portrait) {
      font-size: 1.5rem;
    }
  }
  .features-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
    gap: 10px;
    /* max-width: 900px; */
    max-width: 100%;
    padding-inline: 3%;
    @media (orientation: portrait) {
      padding-inline: 0.5%;
    }
    @media (min-width: 1024px) {
      padding-inline: 9%;
    }
  }
  
  .feature-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;

    @media (orientation: portrait) {
      flex-direction: row;
    }
  }
  .feature-details {
    display: flex;
    flex-direction: column;
    gap: 5px;
    max-width: 900px;
    align-items: center;
    @media (orientation: portrait) {
      align-items: flex-start;
      padding-left: 15px;
    }
  }
  
  .feature-icon {
    width: 60px;
    height: 60px;
    background: rgba(255, 255, 255, 0.1); /* Semi-transparent circle */
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    transition: transform 0.3s ease-in-out;
  }

  .feature-icon img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }

  .feature-icon:hover {
      transform: scale(1.1);
  }
  
  .feature-title {
    font-size: 1.1rem;
    /* white-space: nowrap; */
    line-height: 1.1;
    color: white;
    font-family: 'Nunito-ExtraBold';
    @media (orientation: portrait) {
      text-align: left; /* Ensures left alignment */
      font-size: 1rem;
    }
  }
  
  .feature-description {
    font-size: 0.9rem;
    max-width: 220px;
    line-height: 1.2;
    color: white;
    font-family: 'Nunito-regular';
    @media (orientation: portrait) {
      text-align: left; /* Ensures left alignment */
      font-size: 0.9rem;
    }
  }
  
  .features-image {
    margin-top: 30px;
    display: flex;
    justify-content: center;
  }
  
  .main-image {
    max-width: 60%;
    height: auto;

    @media (orientation: portrait) {
      max-width: 100%;
    }
  }
  
  @media (max-width: 768px) {
    .features-grid {
      grid-template-columns: 1fr 1fr;
    }
  }
  
  @media (max-width: 480px) {
    .features-grid {
      grid-template-columns: 1fr;
    }
  }
  @media (min-width: 768px) and (max-width: 920px) {
    .features-grid {
      grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    }
  }
  @media (min-width: 921px) and (max-width: 1024px) {
    .features-grid {
      grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    }
  }

@keyframes twinkle {
  0% {
    opacity: 0.4;
    transform: scale(0.95);
  }
  100% {
    opacity: 1;
    transform: scale(1.05);
  }
}
.icon-wrapper {
  display: inline-flex;
  margin-block: 10px;
  padding: 10px;
  height: 100px;
  background: rgba(255, 255, 255, 0.301); 
  border-radius: 50%;
  width: 100px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.5);
}

.circular-icon {
  width: 100%;
  height: 100%;
  aspect-ratio: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 25%;
  position: relative;
  overflow: hidden;

  img {
    width: 100%;
    transform-origin: center;
    transform: scale(1.4);
  }

  .sparkles {
    animation: twinkle 2s infinite alternate ease-in-out;
  }
}
  </style>
  